class AboutCarousel extends HTMLElement {
  connectedCallback() {
    if (this.abort) return
    this.abort = new AbortController()
    this.slides = [...this.querySelectorAll('[data-about-slide]')]
    this.tabs = [...this.querySelectorAll('[data-about-index]')]
    this.index = 0
    this.autoplayTimer = null
    this.autoplayPaused = false
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button')
      if (!button) return
      if (button.hasAttribute('data-about-direction')) {
        this.show(this.index + Number(button.dataset.aboutDirection))
      } else if (button.hasAttribute('data-about-index')) {
        this.show(Number(button.dataset.aboutIndex))
      }
    }, { signal: this.abort.signal })
    this.addEventListener('keydown', (event) => {
      if (!event.target.matches('[role="tab"]')) return
      const changes = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 }
      if (!(event.key in changes)) return
      event.preventDefault()
      this.show(changes[event.key])
      this.tabs[this.index].focus()
    }, { signal: this.abort.signal })
    document.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target))
      if (index >= 0) this.show(index)
    }, { signal: this.abort.signal })
    this.addEventListener('pointerenter', () => this.pauseAutoplay(), { signal: this.abort.signal })
    this.addEventListener('pointerleave', () => this.resumeAutoplay(), { signal: this.abort.signal })
    this.addEventListener('focusin', () => this.pauseAutoplay(), { signal: this.abort.signal })
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.resumeAutoplay()
    }, { signal: this.abort.signal })
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stopAutoplay()
      else this.startAutoplay()
    }, { signal: this.abort.signal })
    this.show(0, { restartAutoplay: false })
    this.startAutoplay()
  }

  show(index, { restartAutoplay = true } = {}) {
    if (!this.slides.length) return
    this.index = (index + this.slides.length) % this.slides.length
    this.slides.forEach((slide, position) => { slide.hidden = position !== this.index })
    this.tabs.forEach((tab, position) => {
      tab.setAttribute('aria-selected', String(position === this.index))
      tab.tabIndex = position === this.index ? 0 : -1
    })
    if (restartAutoplay) {
      this.stopAutoplay()
      this.startAutoplay()
    }
  }

  startAutoplay() {
    if (this.autoplayTimer || this.autoplayPaused || this.slides.length < 2 || this.reduceMotion.matches || document.hidden) return
    this.autoplayTimer = window.setInterval(() => {
      this.show(this.index + 1, { restartAutoplay: false })
    }, 5000)
  }

  stopAutoplay() {
    if (!this.autoplayTimer) return
    window.clearInterval(this.autoplayTimer)
    this.autoplayTimer = null
  }

  pauseAutoplay() {
    this.autoplayPaused = true
    this.stopAutoplay()
  }

  resumeAutoplay() {
    this.autoplayPaused = false
    this.startAutoplay()
  }

  disconnectedCallback() {
    this.stopAutoplay()
    this.abort?.abort()
    this.abort = null
  }
}
if (!customElements.get('about-carousel')) customElements.define('about-carousel', AboutCarousel)
